<template>
    <UPopover
        :open="commentPopupVisible"
        class="rounded-md border z-10"
        :reference="activeResourceLinkElement!!"
        :content="{
            align: 'start',
            onEscapeKeyDown: (e: any) => {
                e.preventDefault()
                handleClose()
            }
        }"
    >
        <template #content>
            <div ref="threadsPopover">
                <div class="flex justify-between bg-primary/20">
                    <h3 class="my-auto ml-1.5 font-bold">{{ urn!!.display }}</h3>
                    <UButton
                        color="neutral"
                        variant="ghost"
                        icon="i-lucide-x"
                        title="Lukk"
                        @click="handleClose"
                    />
                </div>
                <div ref="scrollContainerRef" class="flex flex-col" :class="myCommentThreads.length > 0 ? 'h-[500px]' : 'h-50 w-64'">
                    <div class="flex flex-grow h-full">
                        <thread-list
                            v-model:myCommentThreads="myCommentThreads"
                            v-model:detailed-thread="detailedThread"
                            @create-thread="createThread"
                            @toggle-resolve-thread="toggleResolveThread"
                        />
                        <thread v-model:detailed-thread="detailedThread" @create-comment="createComment"/>
                    </div>
                </div>
            </div>
        </template>
    </UPopover>
</template>

<script setup lang="ts">

import {CommentCreate, CommentThread, useComment} from '@/comment/comment.service'
import {onMounted, ref} from 'vue'
import Thread from '@/comment/Thread.vue'
import ThreadList from '@/comment/ThreadList.vue'
import {onClickOutside} from '@vueuse/core'

const {fetchThreadsByUrn, saveComment, resolveThread, closePopup, activeResourceLinkElement, commentThreadUrn: urn, commentPopupVisible} = useComment()

const threadsPopover = ref()
const scrollContainerRef = ref<HTMLElement | null>(null)

const detailedThread = ref<CommentThread>()

const myCommentThreads = ref<CommentThread[]>([])

const getAndSetThreads = async () => {
    if (!urn.value?.identifier) return
    myCommentThreads.value = await fetchThreadsByUrn(urn.value.identifier)
}

const createComment = async (comment: CommentCreate) => {
    myCommentThreads.value = await saveComment(comment)
    detailedThread.value = myCommentThreads.value.find(thread => thread.uuid === comment.thread)
}

const toggleResolveThread = async (thread: CommentThread) => {
    myCommentThreads.value = await resolveThread({thread: thread.uuid, resolved: !thread.resolved})
    detailedThread.value = myCommentThreads.value.find(thread => thread.uuid === thread.uuid)
}

const createThread = async (comment: string) => {
    if (!urn.value) return
    myCommentThreads.value = await saveComment({
        body: comment,
        resourceLink: urn.value,
        thread: null
    })
}

const handleClose = () => {
    closePopup()
    detailedThread.value = undefined
}

onClickOutside(threadsPopover, handleClose)

onMounted(getAndSetThreads)

</script>